"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _TextInput = require("./TextInput.style");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function TextInput(props) {
  var label = props.label,
      type = props.type,
      placeholder = props.placeholder,
      name = props.name,
      fullWidth = props.fullWidth,
      error = props.error,
      errorMessage = props.errorMessage,
      testId = props.testId,
      onChange = props.onChange,
      value = props.value,
      hidden = props.hidden,
      toggleVisibility = props.toggleVisibility,
      disabled = props.disabled,
      renderAction = props.renderAction,
      groupStyle = props.groupStyle,
      rest = _objectWithoutProperties(props, ["label", "type", "placeholder", "name", "fullWidth", "error", "errorMessage", "testId", "onChange", "value", "hidden", "toggleVisibility", "disabled", "renderAction", "groupStyle"]);

  return _react["default"].createElement(_TextInput.TextInputGroup, {
    style: groupStyle
  }, _react["default"].createElement(_TextInput.TextInputLabel, null, label), _react["default"].createElement(_TextInput.Input, _extends({
    type: type,
    placeholder: placeholder,
    name: name,
    fullWidth: fullWidth,
    error: error,
    errorMessage: errorMessage,
    "data-testid": testId,
    onChange: onChange,
    value: value,
    hidden: hidden,
    toggleVisibility: toggleVisibility,
    disabled: disabled,
    renderAction: renderAction
  }, rest)), props.children);
}

var _default = TextInput;
exports["default"] = _default;
TextInput.propTypes = {
  label: _propTypes["default"].string,
  type: _propTypes["default"].string,
  placeholder: _propTypes["default"].string,

  /** Apply styling to the input */
  style: _propTypes["default"].object,
  name: _propTypes["default"].string,
  width: _propTypes["default"].number,
  fullWidth: _propTypes["default"].bool,
  error: _propTypes["default"].bool,
  errorMessage: _propTypes["default"].string,
  testId: _propTypes["default"].string,
  onChange: _propTypes["default"].func.isRequired,
  value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  children: _propTypes["default"].node,
  hidden: _propTypes["default"].bool,
  toggleVisibility: _propTypes["default"].func,
  renderAction: _propTypes["default"].func,

  /** Apply styling to the text input group */
  groupStyle: _propTypes["default"].object
};
TextInput.defaultProps = {
  hidden: true,
  errorMessage: 'This field cannot be empty'
};